import { useState } from 'react'
import { toast } from 'react-toastify'
import store from 'store'
import { _object } from 'utils/interfaces'

const BulkProductUpdate = () => {
  const [excelFile, setExcelFile] = useState<File | null>(null)
  const [results, setResults] = useState<_object>({})

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0]

    if (file && file.name.endsWith('.xlsx')) {
      setExcelFile(file)
    } else {
      setExcelFile(null)
      toast.error('Only .xlsx files are allowed')
    }
  }

  const handleSubmit = async () => {
    if (!excelFile) {
      toast.error('No .xlsx file selected')
      return
    }

    const formData = new FormData()
    formData.append('file', excelFile)

    const accessToken = store.get(process.env.REACT_APP_ACCESS_TOKEN_KEY || '')

    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_URL}/products-import`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          Authorization: accessToken ? accessToken : ''
          // DO NOT set Content-Type manually when sending FormData
        },
        body: formData
      })

      const result = await response.json()

      if (result.error === false) {
        toast.success(result.data.message || 'File uploaded successfully')
        setResults(results)
      } else {
        toast.error(result.data.message || 'Excel upload failed')
      }
    } catch (error) {
      console.error(error)
      toast.error('Upload failed due to a network or server error')
    }
  }

  return (
    <>
      <div className="mb-6">
        <h1 className="text-2xl font-semibold">Bulk Products Update</h1>
      </div>
      <div className="flex gap-4 overflow-x-auto rounded-lg bg-white p-4 shadow">
        <input
          type="file"
          accept=".xlsx"
          onChange={handleFileChange}
          className="rounded-md border px-3 py-2 text-sm outline-none focus:outline-none"
        />

        <button
          type="button"
          onClick={handleSubmit}
          className="rounded-md bg-purple-900 px-4 py-2 text-sm text-white transition hover:bg-purple-950"
        >
          Upload Excel File
        </button>
      </div>
    </>
  )
}

export default BulkProductUpdate
